import React, { useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom';

/* mui */
import Typography from '@material-ui/core/Typography';
/* mui */

/* packages */
  /* Title */
  import { ModuleTitle, ModuleSubTitle, ModuleLink } from '../../util-atomic-design';
  /* Title */
/* packages */

import CONFIG from '../config';

/* CONSTANTS */
const LOGO = CONFIG.setup.assets.logo;
const LANDINGGRAPHICS = CONFIG.setup.assets.landing.default;
/* CONSTANTS */

const response = props => {

  return <Fragment>
    <Typography align="center" gutterBottom>
      <img src={LOGO} width="40%" />
    </Typography>
    <img src={LANDINGGRAPHICS} width="100%"/>
    <ModuleTitle>Great!</ModuleTitle>
    <ModuleSubTitle>You have successfully activated your order.</ModuleSubTitle>
  </Fragment>
}

export default response;
